import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from './analytics';

// Sends a GA4 page_view on every client-side route change. Mount once inside
// <Router>. The initial page_view is fired by gtag('config') in index.html; this
// covers all subsequent SPA navigations so they don't depend on the GA4
// Enhanced Measurement "page changes based on browser history events" setting.
// Renders nothing.
export default function AnalyticsListener() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    // Defer a tick so the new route has committed and document.title is current.
    const id = window.setTimeout(() => {
      trackPageView({ page_path: pathname + search, page_title: document.title });
    }, 0);
    return () => window.clearTimeout(id);
  }, [pathname, search]);

  return null;
}
